import { render, staticRenderFns } from "./gameList.vue?vue&type=template&id=530f4f18"
import script from "./gameList.vue?vue&type=script&lang=js"
export * from "./gameList.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/app.scss?vue&type=style&index=0&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/drone/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('530f4f18')) {
      api.createRecord('530f4f18', component.options)
    } else {
      api.reload('530f4f18', component.options)
    }
    module.hot.accept("./gameList.vue?vue&type=template&id=530f4f18", function () {
      api.rerender('530f4f18', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layout/game/gameList.vue"
export default component.exports